var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PageTemplate", {
    attrs: { isLoggedIn: false, enclosingCssId: "paypoint-login-page" },
    scopedSlots: _vm._u([
      {
        key: "page-content",
        fn: function () {
          return [
            _c(
              "b-container",
              { attrs: { fluid: "", id: "page-container" } },
              [_c("LoginFormDynamic")],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }